import { render, staticRenderFns } from "./CrowdList.vue?vue&type=template&id=5ba4cf6c&scoped=true"
import script from "./CrowdList.vue?vue&type=script&lang=js"
export * from "./CrowdList.vue?vue&type=script&lang=js"
import style0 from "./CrowdList.vue?vue&type=style&index=0&id=5ba4cf6c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba4cf6c",
  null
  
)

export default component.exports